document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.querySelectorAll('.nav__item.has-mega > .nav__link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (window.matchMedia('(max-width: 900px)').matches) {
          var item = link.parentElement;
          if (!item.classList.contains('is-open')) {
            e.preventDefault();
            item.classList.add('is-open');
          }
        }
      });
    });
  }

  // Collection filters toggle (mobile)
  var facetsToggle = document.querySelector('[data-facets-toggle]');
  var facets = document.querySelector('[data-facets]');
  if (facetsToggle && facets) {
    facetsToggle.addEventListener('click', function () { facets.classList.toggle('is-open'); });
  }

  // Sort-by select submits immediately
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  }

  // Quantity buttons
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v += btn.dataset.step === 'up' ? 1 : -1;
        input.value = Math.max(1, v);
      });
    });
  });

  // Product page: gallery thumbs
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var main = document.querySelector('.js-main-img');
      if (!main) return;
      main.src = btn.dataset.src;
      main.srcset = '';
      document.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
      btn.setAttribute('aria-current', 'true');
    });
  });

  // Product page: variant selection
  var productForm = document.querySelector('[data-product-form]');
  var variantData = document.querySelector('[data-variants]');
  if (productForm && variantData) {
    var variants = JSON.parse(variantData.textContent);
    var moneyFormat = productForm.dataset.moneyFormat || '${{amount}}';
    var formatMoney = function (cents) {
      var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, amount);
    };
    var update = function () {
      var selected = [];
      productForm.querySelectorAll('[data-option]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      var idInput = productForm.querySelector('[name="id"]');
      var addBtn = productForm.querySelector('[data-add]');
      if (!match) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        return;
      }
      idInput.value = match.id;
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      var now = document.querySelector('[data-price-now]');
      var retail = document.querySelector('[data-price-retail]');
      var save = document.querySelector('[data-price-save]');
      var retailRow = document.querySelector('[data-retail-row]');
      var saveRow = document.querySelector('[data-save-row]');
      if (now) now.textContent = formatMoney(match.price);
      var onSale = match.compare_at_price && match.compare_at_price > match.price;
      if (retailRow) retailRow.hidden = !onSale;
      if (saveRow) saveRow.hidden = !onSale;
      if (onSale) {
        if (retail) retail.textContent = formatMoney(match.compare_at_price);
        if (save) {
          var pct = Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price);
          save.textContent = formatMoney(match.compare_at_price - match.price) + ' (' + pct + '%)';
        }
      }
      if (match.featured_image) {
        var main = document.querySelector('.js-main-img');
        if (main) { main.src = match.featured_image; main.srcset = ''; }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    };
    productForm.querySelectorAll('[data-option] input').forEach(function (i) { i.addEventListener('change', update); });
  }
});
